import { render, staticRenderFns } from "./ReservationsList.vue?vue&type=template&id=2b711f70&scoped=true&"
import script from "./ReservationsList.vue?vue&type=script&lang=js&"
export * from "./ReservationsList.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsList.vue?vue&type=style&index=0&id=2b711f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b711f70",
  null
  
)

export default component.exports